<template>
  <div id="results">
    <ResultsSuperbet></ResultsSuperbet>
  </div>
</template>

<script>
import ResultsSuperbet from '@/components/Results.Superbet';

export default {
  name: 'PageResultsSuperbet',
  components: {
    ResultsSuperbet,
  },
};
</script>
